<script setup>

import CustomMultiselect from "@/components/global-themed/CustomMultiselect.vue";
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import {useStore} from "vuex";
import {computed} from "vue";
import {getCompetitors} from "@/composables/backlinks/opportunity/useCompetitors";
import useOpportunityStore from "@/composables/backlinks/opportunity/useOpportunityStore";
import SearchInput from "@/components/global-themed/SearchInput.vue";

const store = useStore();

const {search, activeCompetitor } = useOpportunityStore();

const { data: competitors, isFetching } = getCompetitors();

const selectedCompetitor = computed({
  get: () => activeCompetitor.value,
  set: (value) => store.dispatch('backlinkOpportunity/setActiveCompetitor', value)
});

const competitorOptions = computed(() => {
  const options = [
    {
      value: '',
      label: 'All Competitors'
    }
  ];

  if (competitors.value) {
    options.push(...competitors.value.map(competitor => ({
      value: competitor.simpleUrl,
      label: competitor.simpleUrl
    })));
  }

  return options;
});

const onSearchInput = (value) => {
  store.dispatch('backlinkOpportunity/setSearch', value);
}
</script>

<template>
  <div class="tw-grid tw-grid-cols-12 tw-gap-4 tw-items-end tw-py-8">
    <div
      class="tw-col-span-2"
    >
      <CustomMultiselect
        v-model="selectedCompetitor"
        :options="competitorOptions"
        :disabled="isFetching"
        mode="single"
        :close-on-select="true"
        :can-deselect="false"
        :searchable="true"
      />
    </div>

    <div class="tw-col-span-4">
      <SearchInput
        v-model="search"
        placeholder="Search Backlink"
        @update:model-value="onSearchInput"
      />
    </div>

    <div class="tw-col-span-6 tw-flex tw-items-center tw-justify-end tw-gap-4">
      <DefaultButton
        variant="primary-inverted"
        as="a"
        class="py-2 px-4"
        href="/backlinks/opportunity/export"
        size="small"
      >
        <span class="tw-font-semibold tw-antialiased">Export</span>
        <svg-vue
          icon="icons/download"
          class="tw-w-5 tw-h-5 tw-ml-2"
        />
      </DefaultButton>
    </div>
  </div>
</template>

